var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExploreNewRecipeswhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Explore New Recipes"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M3.12525 6.52626C3.69835 4.19111 6.91115 2.95565 8.88324 4.21286C9.73524 3.43272 10.8486 3 12.0038 3C13.159 3 14.2723 3.43272 15.1243 4.21286C19.9521 1.75319 23.6938 8.7984 18.5104 11.033C18.3701 11.0735 18.246 11.1568 18.1553 11.2712C18.0647 11.3857 18.0121 11.5256 18.0048 11.6714V15.7491H6.00274V11.6714C5.99549 11.5256 5.94286 11.3857 5.85221 11.2712C5.76157 11.1568 5.63743 11.0735 5.49715 11.033C4.60898 10.7157 3.87234 10.0764 3.43308 9.2418C2.99382 8.40718 2.88396 7.43804 3.12525 6.52626ZM6.00274 17.2494C5.95681 17.7218 6.00972 18.1985 6.1581 18.6494C6.30648 19.1002 6.54708 19.5152 6.86459 19.868C7.1821 20.2208 7.56956 20.5037 8.00234 20.6985C8.43511 20.8934 8.90371 20.9961 9.37832 21H14.6292C15.1038 20.9961 15.5724 20.8934 16.0052 20.6985C16.438 20.5037 16.8255 20.2208 17.143 19.868C17.4605 19.5152 17.7011 19.1002 17.8494 18.6494C17.9978 18.1985 18.0507 17.7218 18.0048 17.2494H6.00274Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExploreNewRecipeswhite);
export default __webpack_public_path__ + "static/media/Explore New Recipes white.22192065fd010fc67edcfe22a5ef9a7e.svg";
export { ForwardRef as ReactComponent };